export default __webpack_public_path__ + "static/media/2.13062c8a.svg";